import React, {Component} from 'react';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import Inputmask from 'inputmask';

var Config = require('../../../../config');


class TableBlock extends Component{
	constructor(props){
		super(props);

		this.state = {
			expired_date_iluminate:{},
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		var selector = document.getElementsByClassName('hours');
		var im = new Inputmask("--:--");
		im.mask(selector);

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=EXPIRED_DATE_ILUMMINATE&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				expired_date_iluminate: response
			});
		})

		
	}

	render(){
		return (
			<div className="col-xs-12">
				{this.props.option !== "Unit" ?
					<div className="col-xs-12 ">
						<input className="form-check-input" name="all"  type="checkbox" onKeyPress={(e) => this.props.validate(e)} 
							checked={this.props.all} onChange={this.props.selectAll} />
						<span className="span-min" style={{paddingLeft:"5px"}}>Seleccionar Todos</span>
					</div>
				:null}
					
				<div className="col-xs-12 ">
					<Table responsive hover>
						<thead>
							<tr>
								<th></th>
								<th>No. Unidad</th>
								<th>Componente</th>
								<th>No. Subcomponente</th>
								<th>F. de Donación</th>
								<th>F. de Caducidad</th>
								<th>Nueva Fecha de Caducidad</th>
							</tr>
						</thead>
						<tbody>
							{this.props.data.units !== undefined ?
								this.props.data.units.map(function(d, i){
									return d.status !== undefined ?

										d.status.indexOf('RECHAZADA') === -1 ?
											<tr key={i}>
												<td>
													{this.props.option !== "Unit" ?
														<input type="checkbox" id={d.unit.id}  onChange={this.props.checked} 
															onKeyPress={(e) => this.props.validate(e)}
															checked={this.props.checks[i] !== undefined ? this.props.checks[i].check : ""}
															value={this.props.checks[i] !== undefined ? this.props.checks[i].value : ""} />
													:null}
												</td>
												<td>{d.unit.unit_number}</td>
												<td>{d.component === undefined ? d.blood_component.component :d.component.component}</td>
												<td>{d.unit.component_number}</td>
												<td>
													{d.timestamp_date !== null ?
														moment(d.timestamp_date).format('DD/MM/YYYY')
													:''}
												</td>
												<td>{moment(d.unit.caducidad).format('DD/MM/YYYY')}</td>
												<td style={{display:'flex'}}>
													{d.unit.date_caducidad !== undefined && d.unit.date_caducidad !== ""?
														<div style={{display:'flex'}}>
															<input type="date" value={d.unit.date_caducidad} 
																className={d.unit.error_date ? "form-control hour-input error" : "form-control hour-input"} 
																style={{width:'50%', marginRight:'8px'}} id={"date_caducidad_"+d.unit.id} 
																onChange={(e)=>this.props.onChangeData(e, i)}
																disabled={(this.props.process!=="ILUMINADO" && this.props.process !== "ILUMINAR") || 
																			this.state.expired_date_iluminate.value !== "OPEN"}/>

															<input name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
																data-inputmask-placeholder="-" value={d.unit.hour_caducidad}  style={{width:'50%'}}
																className="form-control hours" id={"hour_caducidad_"+d.unit.id} 
																onChange={(e)=>this.props.onChangeData(e, i)}
																disabled={(this.props.process!=="ILUMINADO" && this.props.process !== "ILUMINAR") || 
																			this.state.expired_date_iluminate.value !== "OPEN"}/>	
														</div>
													:null}
												</td>
											</tr>
										: null
									: <tr key={i}>
											<td>
												{this.props.option !== "Unit" ?
													<input type="checkbox" id={d.unit.id}  onChange={this.props.checked} 
														onKeyPress={(e) => this.props.validate(e)}
														checked={this.props.checks[i] !== undefined ? this.props.checks[i].check : ""}
														value={this.props.checks[i] !== undefined ? this.props.checks[i].value : ""} />
												:null}
											</td>
											<td>{d.unit.unit_number}</td>
											<td>{d.component === undefined ? d.blood_component.component :d.component.component}</td>
											<td>{d.unit.component_number}</td>
											<td>
												{d.timestamp_date !== null ?
													moment(d.timestamp_date).format('DD/MM/YYYY')
												:''}
											</td>
											<td>{moment(d.unit.caducidad).format('DD/MM/YYYY')}</td>
											<td >
												{d.unit.date_caducidad !== undefined && d.unit.date_caducidad !== ""?
													<div style={{display:'flex'}}>
														<input type="date" value={d.unit.date_caducidad} 
															className={d.unit.error_date ? "form-control hour-input error" : "form-control hour-input"} 
															style={{width:'50%', marginRight:'8px'}} id={"date_caducidad_"+d.unit.id} 
															onChange={(e)=>this.props.onChangeData(e, i)}
															disabled={(this.props.process!=="ILUMINADO" && this.props.process !== "ILUMINAR") || 
																		this.state.expired_date_iluminate.value !== "OPEN"}/>

														<input name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
															data-inputmask-placeholder="-" value={d.unit.hour_caducidad}  style={{width:'50%'}}
															className="form-control hours"  id={"hour_caducidad_"+d.unit.id} 
															onChange={(e)=>this.props.onChangeData(e, i)}
															disabled={(this.props.process!=="ILUMINADO" && this.props.process !== "ILUMINAR") || 
																		this.state.expired_date_iluminate.value !== "OPEN"}/>	
													</div>
												:null}
														
													
											</td>
										</tr>
								}.bind(this))

							:null}
							{/*
								this.props.data.map(function(d, i){
									return <tr key={i}>
												<td>
													<input type="checkbox" id={d.unit.id}  onChange={this.props.checked} 
														onKeyPress={(e) => this.props.validate(e)}
														checked={this.props.checks[i] !== undefined ? this.props.checks[i].check : ""}
														value={this.props.checks[i] !== undefined ? this.props.checks[i].value : ""} />
													
												</td>
												<td>{d.unit.unit_number}</td>
												<td>{d.component === undefined ? d.blood_component.component :d.component.component}</td>
												<td>{d.unit.component_number}</td>
												<td>{moment(d.donation_date).format('DD/MM/YYYY')}</td>
											</tr>
								}.bind(this))
							*/}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}
}

export default TableBlock;